"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _brandSelection = require("@/api/brandSelection");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: [],
  data: function data() {
    return {
      dialogVisible1: false,
      ruleForm: {
        bgColor: '',
        picUrl: ''
      },
      rules: {
        picUrl: [{
          required: false
        }],
        bgColor: [{
          required: false
        }]
      }
    };
  },
  methods: {
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm.picUrl = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    open: function open(data) {
      console.log(data);
      this.ruleForm = data;
      this.dialogVisible1 = true;
    },
    onClose: function onClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible1 = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _brandSelection.save_act)((0, _objectSpread2.default)({}, _this.ruleForm)).then(function (res) {
            if (res.data) {
              _this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};